import { Shield, Eye, Edit } from 'lucide-preact'
import type { RoleType } from '@/types/userRoles'

// Role icons and colors mapping
const ROLE_CONFIG = {
  Viewer: {
    icon: Eye,
    textColor: 'text-slate-500 dark:text-slate-400',
    overriddenTextColor: 'text-slate-700 dark:text-white',
    bgColor: 'bg-slate-100 dark:bg-slate-700'
  },
  Editor: {
    icon: Edit,
    textColor: 'text-amber-600 dark:text-amber-400',
    overriddenTextColor: 'text-amber-600 dark:text-amber-400',
    bgColor: 'bg-amber-100 dark:bg-amber-900/20'
  },
  Admin: {
    icon: Shield,
    textColor: 'text-red-600 dark:text-red-400',
    overriddenTextColor: 'text-red-600 dark:text-red-400',
    bgColor: 'bg-red-100 dark:bg-red-900/20'
  }
} as const

// Role badge component
export function RoleBadge({ role, isOverridden = false }: { role: RoleType; isOverridden?: boolean }) {
  const config = ROLE_CONFIG[role]
  const IconComponent = config.icon

  // Get the appropriate text color class
  const getTextColorClass = () => {
    if (isOverridden && role === 'Viewer') {
      return config.overriddenTextColor
    }
    return config.textColor
  }

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${config.bgColor} border border-slate-200 dark:border-slate-600 ${isOverridden ? 'opacity-90' : ''
        } ${getTextColorClass()}`}
    >
      <IconComponent className="w-3 h-3" />
      {role}
      {isOverridden && (
        <span className="ml-1 text-xs opacity-75">*</span>
      )}
    </span>
  )
}
